<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <h3 class="box-title">
        {{ $t('string.show_team') }}
      </h3>
      <div class="box-tools">
        <ButtonBack />
      </div>
    </div>
    <div class="box-body">
      <div class="table-responsive">
        <table
          v-if="team"
          class="table table-striped table-bordered"
        >
          <tbody>
            <tr>
              <td>{{ $t('field.label.team_name_km') }}</td>
              <td>{{ team.name_km }}</td>
            </tr>
            <tr>
              <td>{{ $t('field.label.team_name_en') }}</td>
              <td>{{ team.name_en }}</td>
            </tr>
            <tr>
              <td>{{ $t('field.label.team_leader') }}</td>
              <td>{{ leader }}</td>
            </tr>
            <tr>
              <td>{{ $t('field.pla.member') }}</td>
              <td>{{ members }}</td>
            </tr>
            <tr>
              <td>{{ $t('field.label.provinces') }}</td>
              <td>{{ provinces }}</td>
            </tr>
            <tr>
              <td>{{ $t('field.label.reference_number') }}</td>
              <td>{{ team.reference_number || $t('string.na') }}</td>
            </tr>
            <tr>
              <td>{{ $t('field.label.description') }}</td>
              <td>{{ team.description || $t('string.na') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonBack from '@/components/ButtonBack'
export default {
  name: 'Show',
  components: { ButtonBack },
  metaInfo () {
    return {
      title: this.$t('string.show_team'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  data () {
    return {
      team: null
    }
  },
  computed: {
    leader () {
      if (this.team && this.team.leader) {
        const { first_name, last_name } = this.team.leader
        return `${first_name} ${last_name}`
      }
      return this.$t('string.na')
    },
    members () {
      if (this.team && this.team.members && Array.isArray(this.team.members) && this.team.members.length > 0) {
        return this.team.members.map(m => `${m.first_name} ${m.last_name}`).join(', ')
      }
      return this.$t('string.na')
    },
    provinces () {
      if (this.team && this.team.provinces && Array.isArray(this.team.provinces) && this.team.provinces.length > 0) {
        return this.team.provinces.map(m => m['name_' + this.$i18n.locale]).join(', ')
      }
      return this.$t('string.na')
    }
  },
  mounted () {
    this.getTeam()
  },
  methods: {
    getTeam () {
      this.$isLoading(true)
      this.$axios.get(process.env.VUE_APP_API + '/api/backend/teams/' + this.$route.params.team_uuid, {
        team_uuid: this.$route.params.team_uuid
      }).then(({ data }) => {
        if (data.data) {
          this.team = data.data
        }
      }).finally(() => {
        this.$isLoading(false)
      })
    }
  }
}
</script>

<style scoped>
.control-label {
  padding-top: 0 !important;
}

.column-officer-avatar {
  text-align: center;
  width: 15%;
}

.column-officer-avatar img.thumbnail {
  display: inline-table;
  width: 100%;
}

.table > tbody > tr > td {
  vertical-align: middle !important;
}

@media screen and (max-width: 1200px) {
  .column-officer-avatar {
    width: 25%;
  }
}
</style>
